import { useReveal } from '../lib/anim/useReveal';

const ROWS = [
  { label: 'Stack engineering', hire: '4–6 weeks', clarity: 'already built' },
  { label: 'Auth + RLS + Stripe', hire: '2 weeks', clarity: 'already built' },
  { label: 'First engine', hire: '6 weeks', clarity: 'configure in a day' },
  { label: 'AI advisor', hire: '4 weeks + KB cost', clarity: 'included' },
  { label: 'Time to a paying customer', hire: '3–6 months', clarity: '7 days' },
];

export function MathStrip() {
  const sectionHeading = useReveal();
  const tableReveal = useReveal({ delay: 1 });

  return (
    <section
      className="py-24"
      style={{ background: 'var(--color-bg)', borderTop: '1px solid var(--color-hairline)' }}
    >
      <div className="max-w-5xl mx-auto px-6">
        <div
          ref={sectionHeading.ref}
          {...sectionHeading.props}
          className={`mb-10${sectionHeading.props.className ? ' ' + sectionHeading.props.className : ''}`}
        >
          <p className="eyebrow" data-r>
            <span className="eyebrow-dash" />
            <span>THE MATH</span>
          </p>
          <h2
            className="text-2xl md:text-3xl font-bold max-w-lg"
            style={{ fontFamily: 'var(--font-display)', color: 'var(--color-ink)' }}
          >
            Most of the work is already done.
          </h2>
        </div>

        <div
          ref={tableReveal.ref}
          {...tableReveal.props}
          className={tableReveal.props.className}
        >
          {/* Column headers */}
          <div
            className="grid grid-cols-3 gap-0 mb-1"
            style={{ borderBottom: '1px solid var(--color-hairline)' }}
          >
            <div
              className="py-2 text-xs font-semibold uppercase tracking-[0.08em]"
              style={{ color: 'var(--color-mute)', fontFamily: 'var(--font-body)' }}
            >
              Task
            </div>
            <div
              className="py-2 text-xs font-semibold uppercase tracking-[0.08em] text-center"
              style={{ color: 'var(--color-mute)', fontFamily: 'var(--font-body)' }}
            >
              Hire devs to build it
            </div>
            <div
              className="py-2 text-xs font-semibold uppercase tracking-[0.08em] text-center"
              style={{
                color: 'var(--color-accent)',
                fontFamily: 'var(--font-body)',
              }}
            >
              Ship on Clarity
            </div>
          </div>

          {/* Rows */}
          {ROWS.map((row, i) => (
            <div
              key={row.label}
              data-r
              style={{
                borderBottom: i < ROWS.length - 1 ? '1px solid var(--color-hairline)' : undefined,
                transitionDelay: `${i * 120}ms`,
              }}
              className="grid grid-cols-3 gap-0 items-center"
            >
              <div
                className="py-3.5 text-sm"
                style={{ color: 'var(--color-ink)', fontFamily: 'var(--font-body)' }}
              >
                {row.label}
              </div>
              <div
                className="py-3.5 text-sm text-center"
                style={{ fontFamily: 'var(--font-mono)', color: 'var(--color-mute)' }}
              >
                {row.hire}
              </div>
              <div
                className="py-3.5 text-sm text-center"
                style={{
                  fontFamily: 'var(--font-mono)',
                  color: 'var(--color-ink)',
                  fontWeight: 500,
                  background: 'var(--color-accent-soft)',
                  borderLeft: '1px solid var(--color-hairline)',
                  paddingLeft: '12px',
                }}
              >
                {row.clarity}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
